import axios from "axios";

export function getCountries() {
	return axios.get(`${process.env.REACT_APP_SISAPI_ONDEMAND}/paises/`);
}

export function getThematics() {
	return axios.get(`${process.env.REACT_APP_SISAPI_ONDEMAND}/acropolis/ejes_tematicos/0`);
}

export async function getAllCountries() { 
	try {
        const response = await axios.get(`${process.env.REACT_APP_REPOURL}/v2/repo_aden/miscs/countries`);
        return response;
    } catch (error) {
        return {
            error,
        };
    }
}
